import { EmptyBox } from '@/components/EmptyBox';
import {
  api_portalOfficeListing_filter,
  api_portalOfficeHospitalListing_medicalSubject,
  api_portalOfficeListingAllType_portalOfficeResponse,
} from '@/init/swagger';
import { Box } from '@mui/material';
import { asHospitalListing } from '@/helpers/parseHospitalListings';
import { PublicHomeStationListingCard } from './PublicHomeStationListingCard';
import { PublicHomeHospitalListingCard } from './PublicHomeHospitalListingCard';

type Props = {
  portalOfficeListings: api_portalOfficeListingAllType_portalOfficeResponse[];
  searchFilters: api_portalOfficeListing_filter[];
  hospitalMedicalSubjects: api_portalOfficeHospitalListing_medicalSubject[];
};

export function PublicHomeSearchResults({
  portalOfficeListings,
  searchFilters,
  hospitalMedicalSubjects,
}: Props) {
  if (portalOfficeListings.length === 0) {
    return (
      <Box sx={{ mx: 2 }}>
        <EmptyBox
          mainMessage="ご指定の条件に該当する看護・介護サービス・医療機関が見つかりませんでした"
          subMessage="検索条件を変更して、再度検索してください。"
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {portalOfficeListings.map((portalOfficeListing, listingIndex) => (
        <Box key={listingIndex} mb={2}>
          {portalOfficeListing.portal_office_listing && (
            <PublicHomeStationListingCard
              listing={portalOfficeListing.portal_office_listing}
              searchFilters={searchFilters}
            />
          )}
          {portalOfficeListing.portal_office_hospital_listing && (
            <PublicHomeHospitalListingCard
              listing={asHospitalListing(
                portalOfficeListing.portal_office_hospital_listing,
              )}
              hospitalMedicalSubjects={hospitalMedicalSubjects}
            />
          )}
        </Box>
      ))}
    </Box>
  );
}
